export enum EndUserCertKeyType {
  Unknown, // EU_CERT_KEY_TYPE_UNKNOWN
  DSTU4145 = 1, // EU_CERT_KEY_TYPE_DSTU4145
  RSA = 2, // EU_CERT_KEY_TYPE_RSA
  ECDSA = 4 // EU_CERT_KEY_TYPE_ECDSA
}

export enum EndUserSignAlgo {
  Unknown = 0, // EU_CTX_SIGN_UNKNOWN
  DSTU4145WithGOST34311 = 1, // EU_CTX_SIGN_DSTU4145_WITH_GOST34311
  RSAWithSHA = 2, // EU_CTX_SIGN_RSA_WITH_SHA
  ECDSAWithSHA = 3 // EU_CTX_SIGN_ECDSA_WITH_SHA
}

export enum EndUserHashAlgo {
  Unknown = 0, // EU_CTX_HASH_ALGO_UNKNOWN
  GOST34311 = 1, // EU_CTX_HASH_ALGO_GOST34311
  SHA160 = 2, // EU_CTX_HASH_ALGO_SHA160
  SHA224 = 3, // EU_CTX_HASH_ALGO_SHA224
  SHA256 = 4 // EU_CTX_HASH_ALGO_SHA256
}

export enum CloudProvider {
  DepositSign = 'DepositSign',
  DPDiya = 'DPDiya',
  PrivatSmartId = 'PrivatSmartId',
  Ukey = 'Ukey',
  CloudKey = 'CloudKey',
  ESign = 'ESign'
}

export enum DepositSignAuthType {
  TwoFactor = 'TwoFactor',
  LoginPassword = 'LoginPassword'
}

export enum PrivateKeyType {
  Key = 'Key',
  Seal = 'Seal'
}

export enum SignMethod {
  FileSystem = 'FileSystem',
  Device = 'Device',
  Cloud = 'Cloud'
}

export enum SignPurpose {
  None = 0,
  Document = 1,
  ConfirmDocumentReceipt = 2,
  Files = 3,
  Registration = 4,
  Authentication = 5,
  AddSignatureToLogin = 6,
  ChangeAccountToOrganization = 7,
  AddMyOrganization = 8,
  AddNewCertificate = 9,
  ChangeOrganizationName = 10,
  RegistrationCompletion = 11
}

export enum CloudKeyReaderType {
  FileSystem = 'FileSystem',
  QrCode = 'QrCode'
}

export enum EndUserEventType {
  None = 0,
  All = 1,
  ConfirmKSPOperation = 2
}

export enum ExtKeyUsagesSeal {
  Default = '1.2.804.2.1.1.1.3.9',
  Bluetooth = 'цифрова печатка'
}

export enum AppSignTab {
  Sign = 0,
  Seal = 1
}

export enum AppSignKeySelectorTab {
  FileSystem = 0,
  Device = 1,
  // MobileId = 2,
  Cloud = 2
}

export enum AppSignKeyOperationType {
  Reading = 0,
  Signing = 1
}
